var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlatware(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5102_18242",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5102_18242)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.20356 27.6663V14.41C6.47867 14.3929 5.86156 14.1339 5.35222 13.633C4.84267 13.1321 4.58789 12.5193 4.58789 11.7947V5.08701C4.58789 4.87145 4.65978 4.6919 4.80356 4.54834C4.94711 4.40479 5.12656 4.33301 5.34189 4.33301C5.55722 4.33301 5.73667 4.40479 5.88022 4.54834C6.02378 4.6919 6.09556 4.87145 6.09556 5.08701V9.66634H7.44956V5.08701C7.44956 4.87145 7.52133 4.6919 7.66489 4.54834C7.80845 4.40479 7.98789 4.33301 8.20322 4.33301C8.41878 4.33301 8.59833 4.40479 8.74189 4.54834C8.88545 4.6919 8.95722 4.87145 8.95722 5.08701V9.66634H10.3112V5.08701C10.3112 4.87145 10.383 4.6919 10.5266 4.54834C10.6701 4.40479 10.8496 4.33301 11.0649 4.33301C11.2802 4.33301 11.4597 4.40479 11.6032 4.54834C11.7468 4.6919 11.8186 4.87145 11.8186 5.08701V11.7947C11.8186 12.5193 11.5639 13.1321 11.0546 13.633C10.5452 14.1339 9.92811 14.3929 9.20322 14.41V27.6663H7.20356ZM16.2802 27.6663V14.328C15.3727 13.9005 14.7013 13.238 14.2662 12.3407C13.8311 11.4433 13.6136 10.4852 13.6136 9.46634C13.6136 8.15167 13.9294 6.96745 14.5612 5.91367C15.1928 4.8599 16.0991 4.33301 17.2802 4.33301C18.4613 4.33301 19.3678 4.8599 19.9996 5.91367C20.6311 6.96745 20.9469 8.15167 20.9469 9.46634C20.9469 10.4852 20.7293 11.4433 20.2942 12.3407C19.8593 13.238 19.188 13.9005 18.2802 14.328V27.6663H16.2802ZM22.8956 27.6663V4.35868C24.1742 4.45268 25.246 4.97912 26.1109 5.93801C26.976 6.89712 27.4086 8.02879 27.4086 9.33301V16.9997H24.8956V27.6663H22.8956Z",
    fill: "#1C1B1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlatware);
export default __webpack_public_path__ + "static/media/flatware.621c7fc1fc3b098026aa6c4e1e3d3a00.svg";
export { ForwardRef as ReactComponent };